__webpack_require__.p = "/Portfolio-Using-React-and-Chakra-UI/";